var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKnetIconnn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 18,
    viewBox: "0 0 23 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.55556 0C1.14601 0 0 1.15313 0 2.57143V3.85714H23V2.57143C23 1.15313 21.854 0 20.4444 0H2.55556ZM23 7.71429H0V15.4286C0 16.8469 1.14601 18 2.55556 18H20.4444C21.854 18 23 16.8469 23 15.4286V7.71429ZM4.47222 12.8571H7.02778C7.37917 12.8571 7.66667 13.1464 7.66667 13.5C7.66667 13.8536 7.37917 14.1429 7.02778 14.1429H4.47222C4.12083 14.1429 3.83333 13.8536 3.83333 13.5C3.83333 13.1464 4.12083 12.8571 4.47222 12.8571ZM8.94444 13.5C8.94444 13.1464 9.23194 12.8571 9.58333 12.8571H14.6944C15.0458 12.8571 15.3333 13.1464 15.3333 13.5C15.3333 13.8536 15.0458 14.1429 14.6944 14.1429H9.58333C9.23194 14.1429 8.94444 13.8536 8.94444 13.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnetIconnn);
export default __webpack_public_path__ + "static/media/Knet-iconnn.33615a250a9b3da0eaac07c48a268b16.svg";
export { ForwardRef as ReactComponent };